import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Get } from "../../../apis/api";
import { useParams, useSearchParams } from "react-router-dom";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import { useSelector } from "react-redux";
import clsx from 'clsx';
import { Information } from './sections/Information/Information';
import { useCrewInfo } from './hooks';
import { Documents } from './sections/Documents/Documents';

export const SingleCrew = () => {

  const { step, dispatch } = useCrewInfo()

  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const lng = useSelector((state) => (state as any).common.lng)
  const [params] = useSearchParams()

  const defStep = params.get('def')

  useEffect(() => {

    if (defStep == 'docs')
      dispatch({ step: 2 })
    else
      dispatch({ step: 1 })
  }, [defStep])




  const handleStep = () => {
    // eslint-disable-next-line default-case
    switch (step) {
      case 1:
        return (
          <Information />
        )
      case 2:
        return (
          <Documents />
        )
    }
  }

  return (
    <div className={clsx("mb-10", lng == 'fa' ? '' : 'ltr')}>
      {
        loading && <LoadingFix />
      }
      <div className={"my-container rounded-lg flex justify-between items-center w-full"}>
        <div className={"flex gap-10"}>
          <div onClick={() => dispatch({ step: 1 })} className={`text-gray-700 border-b-2 p-2 ${step === 1 ? " bg-main/5  border-primary-900 text-primary-900" : " border-transparent  "} font-medium cursor-pointer`}>
            {t("Information")} {t('crew')}
          </div>
          <div onClick={() => dispatch({ step: 2 })} className={`text-gray-700 border-b-2 p-2 ${step === 2 ? " bg-main/5  border-primary-900 text-primary-900" : " border-transparent  "}} font-medium cursor-pointer`}>
            {t("Documents")} {t('crew')}
          </div>
        </div>
      </div>
      {
        handleStep()
      }
      <div>

      </div>
    </div>
  );
};


